import Immutable from "immutable";

import api from "../../lib/api";

// ------------------------------------
// Actions
// ------------------------------------

export const HYDRATE = "@app/clock/HYDRATE";

// ------------------------------------
// Action generators
// ------------------------------------

export const hydrate = (id, zipcode, time) => ({
  type: HYDRATE,
  payload: api.post("/clock").send({
    id,
    zipcode: zipcode && zipcode.trim().replace(/\s+/, " "),
    time
  })
});

// ------------------------------------
// Default State
// ------------------------------------

const State = Immutable.Record({
  isFetching: true,
  hasFetched: false,
  data: Immutable.Map(),
  error: null
});

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [HYDRATE]: (state, { status, payload }) => {
    switch (status) {
      case "pending":
        return state.set("isFetching", true);
      case "success":
        return state
          .set("isFetching", false)
          .set("hasFetched", true)
          .set("data", Immutable.fromJS(payload));
      case "error":
        return state.set("isFetching", false).set("error", payload);
    }
    return state;
  }
  // [HYDRATE_CONTEXT]: (state, { status, payload }) => {
  //   if (status === 'success' && payload && payload.deliverability && payload.deliverability.time) {
  //     return Immutable.fromJS(payload.deliverability);
  //   }
  //   return state;
  // },
};

// ------------------------------------
// Reducer
// ------------------------------------

export default function reducer(state = new State(), action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
